'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _redux = require('./features/redux');

var _user = require('./actions/user');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gathers action creators from a `Component`'s static property `fetch` and
 * returns a promise. Resolving the promise  dispatches each action with the
 * matched route params object.
 *
 * @param store dispatches the action creators
 * @param renderProps used to destructure component tree and matched route params
 * @param req the express req object. be careful passing too much of this into state
 * @param backplane the backplane `api` object.
 *
 * @returns {Promise} component tree actions creators to dispatch
 */
var hydrate = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(store, _ref2, req, backplane) {
    var components = _ref2.components,
        params = _ref2.params;
    var componentsWithFetch;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            componentsWithFetch = components.filter(function (comp) {
              return !comp.rootContainer;
            }).reduce(function (prev) {
              var current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              return (current.fetch || []).concat(prev);
            }, []);


            store.dispatch({
              type: _user.FETCH_USER_FAVORITES_SUCCESS,
              favorites: backplane.favorites.data.favorites
            });

            store.dispatch({
              type: _user.FETCH_USER_SETTINGS_SUCCESS,
              settings: backplane.settings
            });

            if (backplane.details) {
              store.dispatch({
                type: _user.FETCH_USER_DETAILS_SUCCESS,
                details: backplane.details
              });
            }

            if (backplane.entitlements) {
              store.dispatch({
                type: _user.FETCH_USER_ENTITLEMENTS_SUCCESS,
                entitlements: backplane.entitlements.entitlements
              });
            }

            store.dispatch({ type: _redux.LOAD_IDENTITY, identity: backplane.features.identity });

            store.dispatch({
              type: _redux.SETUP_FEATURE_FLAGS,
              treatments: backplane.features.treatments
            });

            return _context.abrupt('return', _promise2.default.all(componentsWithFetch.map(function (doFetch) {
              return store.dispatch(doFetch(params, req));
            })));

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function hydrate(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = hydrate;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/web-common/dist/hydrate.js
// module id = 717
// module chunks = 11